import { ChevronDown } from 'lucide-react';
import { useRef } from 'react';
import { useFilterV3Context } from '../../contexts/FilterV3.context';
import { FilterStep } from '../../filter.types';
import FilterChip from '../FilterChip/FilterChip';

interface FixedFilterChipProps {
  label: string;
  filterIndex: number;
  testId?: string;
}

const FixedFilterChip = ({ label, filterIndex, testId }: FixedFilterChipProps) => {
  const { onChangeAnchorEl, onChangeMenu, anchorEl, menu } = useFilterV3Context();
  const anchorRef = useRef<HTMLDivElement | null>(null);

  const isOpen = !!anchorEl && menu.filterIndex === filterIndex;

  const handleOpenMenu = () => {
    if (!anchorRef.current) {
      return;
    }

    onChangeAnchorEl(anchorRef.current);
    onChangeMenu({
      filterIndex,
      step: FilterStep.SECOND_STEP,
    });
  };

  return (
    <FilterChip
      ref={anchorRef}
      testId={testId}
      isActive={isOpen}
      primaryLabel={label}
      onLabelClick={handleOpenMenu}
      secondAction={{ icon: ChevronDown, onClick: handleOpenMenu, rotated: isOpen }}
    />
  );
};

export default FixedFilterChip;
